/**
 * Layout-persisted config: identity only. Display preferences
 * (interval, binSize, view) live in `stores/biomassDistributionPreferences.ts`.
 */
export interface BiomassDistributionConfig {
  sensorId: string;
  sensorName: string;
}

export enum BiomassDistributionView {
  Chart = 'chart',
  Table = 'table',
}

export enum BiomassDistributionInterval {
  Day = 'daily',
  Week = 'weekly',
  Month = 'monthly',
}

export enum BiomassDistributionBinSize {
  Small = 'small',
  SmallMedium = 'smallmedium',
  Medium = 'medium',
  Large = 'large',
}

export const intervalToDuration = {
  [BiomassDistributionInterval.Day]: { days: 1 },
  [BiomassDistributionInterval.Week]: { weeks: 1 },
  [BiomassDistributionInterval.Month]: { months: 1 },
};
